import { useEffect, useState } from 'react';

// Use the splash screen only if not in PWA mode
const isPWA = window.matchMedia('(display-mode: standalone)').matches;

interface UseSplashScreen {
  timeBeforeFadeOut: number;
  fadeOutTime: number;
}

function useSplashScreen({ timeBeforeFadeOut, fadeOutTime }: UseSplashScreen) {
  const [show, setShow] = useState(!isPWA);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    setTimeout(() => setFadeOut(true), timeBeforeFadeOut);
  }, [timeBeforeFadeOut]);

  useEffect(() => {
    setTimeout(() => setShow(false), timeBeforeFadeOut + fadeOutTime);
  }, [timeBeforeFadeOut, fadeOutTime]);

  return { show, fadeOut, fadeOutTime };
}

export default useSplashScreen;
